<template>
    <v-card>
        <v-card-text>
            <v-row>
                <v-col>
                    <div class="font-weight-bold mt-6 title-page" tabindex="0">Login</div>
                    <p class="mt-2" tabindex="0">
                        Realize o login para acessar a Área do
                        <span v-if="isProcurador">Procurador/Inventariante</span>
                        <span v-else>Credor</span>.
                    </p>
                </v-col>
            </v-row>
            <v-form ref="form" v-model="validForm">
                <v-row>
                    <v-col>
                        <v-text-field dense id="username" label="E-mail" v-model="dataset.data.email" required
                            :rules="[$rules.required]" outlined hide-details="auto"
                            aria-label="Area de texto para digitar seu email de acesso ao site"
                            @blur="dataset.data.email = (dataset.data.email || '').trim()">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col>
                        <v-text-field dense outlined label="Senha"
                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" required :rules="[$rules.required]"
                            :type="showPassword ? 'text' : 'password'" v-model="dataset.data.password"
                            @click:append="showPassword = !showPassword" hide-details="auto" class="mb-4" id="password"
                            aria-label="Area de texto para digitar a senha de acesso ao site"
                            @blur="dataset.data.password = (dataset.data.password || '').trim()">
                        </v-text-field>
                    </v-col>
                </v-row>

                <!-- Checkbox -->
                <v-row>
                    <v-col>
                        <v-checkbox v-model="isProcurador" label="Entrar como procurador/inventariante" hide-details
                            class="mb-4 font-weight-bold"></v-checkbox>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col>
                        <p tabindex="0">
                            Esqueceu sua senha? <a href="#" @click.prevent="openForgotPassword" tabindex="0"
                                aria-label="Caso não se lembre mais de sua senha de acesso, este é o link para recuperar sua senha">Clique
                                aqui</a>
                        </p>
                        <p tabindex="0">
                            Você ainda não possui uma conta? <a href="#" @click.prevent="openRegisterDialog"
                                aria-label="Caso não tenha efetuado cadastro no site, este é o link para realizar o cadastro">Clique
                                aqui</a>
                        </p>
                    </v-col>
                </v-row>
            </v-form>
            <v-row>
                <v-col>
                    <v-btn color="primary" @click.native="login" :loading="loading" tabindex="0"
                        aria-label="Botão para entrar no site depois de digitar o login e senha">Entrar</v-btn>
                    <v-btn color="grey" text @click.native="goBack" tabindex="0"
                        aria-label="Botão para retornar ao site sem fazer login">Cancelar</v-btn>
                </v-col>
            </v-row>
        </v-card-text>

        <!-- 🔹 Modal de conta não verificada -->
        <v-dialog v-model="showVerificationDialog" max-width="600px" persistent>
            <v-card class="pa-4 rounded-xl">
                <v-card-text class="text-body-2">
                    <div class="d-flex align-center justify-center mb-5">
                        <v-icon color="amber darken-2" size="36" class="mr-2">mdi-alert</v-icon>
                        <span class="text-h6 font-weight-bold">
                            Sua conta ainda não foi verificada!
                        </span>
                    </div>

                    <v-divider class="my-2"></v-divider>

                    <p class="mb-3 mt-5">
                        Um e-mail com instruções foi enviado no momento do cadastro.
                    </p>

                    <p class="mb-3">
                        Verifique a caixa de entrada do e-mail
                        <strong>{{ dataset.data.email }}</strong>
                        e siga as instruções para ativar sua conta.
                    </p>

                    <p class="mb-3">
                        Caso não tenha recebido, verifique no
                        <strong>spam</strong> e no <strong>lixo eletrônico</strong>.
                    </p>

                    <p>
                        Se ainda assim não encontrar, clique no botão abaixo para reenviar o e-mail de verificação.
                    </p>

                    <div class="mt-3 text-caption grey--text">
                        Nota: somente o último e-mail de verificação enviado será validado.
                    </div>
                </v-card-text>
                <v-card-actions class="justify-end mt-2">
                    <v-btn color="primary" class="px-6" :loading="resending" @click="resendVerificationEmail">
                        <v-icon left>mdi-email-send-outline</v-icon>
                        Reenviar e-mail
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn text color="grey darken-1" class="ml-5" @click="showVerificationDialog = false">
                        Fechar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-card>
</template>

<script>
import 'moment/locale/pt-br';

import * as jwt from "jwt-decode";

import { eventHub } from "@/main";

import axios from "axios"

import router from '../../router';

export default {
    data: () => ({
        showPassword: false,
        validForm: false,
        loading: false,
        isProcurador: false,
        dataset: {
            data: {}        
        },
        showVerificationDialog: false,
        resending: false,
    }),

    methods: {

        openRegisterDialog() {
            eventHub.$emit('DIALOG-REGISTER', true)
        },

        openForgotPassword() {
            this.goBack();
            eventHub.$emit('DIALOG-FORGOT-PASSWORD', true)
        },

        goBack() {
            eventHub.$emit('DIALOG-ACCESS', false)
        },

    // async login() {
    //     if (!this.$refs.form.validate()) return;

    //     const data = {
    //         email: this.dataset.data.email,
    //         password: this.dataset.data.password
    //     };

    //     const url = this.isProcurador ? '/api/lawyer/login' : '/api/login';

    //     this.loading = true;

    //     try {
    //         const result = await axios.post(url, data);

    //         if (!result.data.status) throw new Error();

    //         const dataUser = { 
    //             name: result.data.content.name, 
    //             type: this.isProcurador ? 'lawyer' : 'user' 
    //         };
            
    //         this.$root.user = dataUser;
    //         localStorage.setItem('user', JSON.stringify(dataUser));
    //         localStorage.setItem('token', JSON.stringify(result.data.content.token));

    //         this.goBack();

    //         const redirectRoute = this.isProcurador ? '/home' : '/home';
    //         router.push(redirectRoute);

    //     } catch (error) {
    //         this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
    //         this.dataset.data.password = "";
    //     } finally {
    //         this.loading = false;
    //     }
    // }


        async login() {
            if (!this.$refs.form.validate()) return;

            const data = {
                email: (this.dataset.data.email || '').trim(),
                password: (this.dataset.data.password || '').trim()
            };

            const url = this.isProcurador ? '/api/lawyer/login' : '/api/login';

            this.loading = true;

            try {
                const result = await axios.post(url, data);

                if (!result.data.status) throw new Error();
                
                localStorage.setItem('token', JSON.stringify(result.data.content));
                
                const dataUser = jwt(result.data.content.token)
                this.$root.user = dataUser.data;
                
                console.log('data user ', dataUser)

                localStorage.setItem('user', JSON.stringify(dataUser.data));

                this.goBack();

                router.go("/home");

            } catch (error) {
                console.log('error ', error)

                this.goBack();

                if (error.response && error.response.status === 405) {
                    this.showVerificationDialog = true;
                } else {
                    
                    const msg = this.$codes ? this.$codes(error) : 'Erro ao efetuar login.';
                    this.$dialog.notify.error(msg, { position: 'top-right', timeout: 5000 });
                }
                this.dataset.data.password = "";
            } finally {
                this.loading = false;
            }
        },

        async resendVerificationEmail() {

            const url = this.isProcurador ? '/api/lawyers/account-verification' : '/api/users/account-verification';

            this.resending = true;
            try {
                await axios.post(url, { email: this.dataset.data.email });
                
                this.$dialog.notify.success('E-mail de verificação reenviado com sucesso!', { position: 'top-right', timeout: 5000 });

                this.showVerificationDialog = false;

                await this.$dialog.confirm({
                    html: true, // garante que o texto aceite HTML
                    title: 'Sucesso',
                    text: `Um e-mail foi enviado para <strong>${this.dataset.data.email}</strong>. 
                            <br>Acesse-o para verificar sua conta.`,
                    actions: {
                        true: 'OK'
                    }
                });

            } catch (error) {
                if (error.response && error.response.data && error.response.data.message) {
                    this.$dialog.notify.warning(error.response.data.message, {
                        position: 'top-right',
                        timeout: 5000,
                    });
                } 
                else if (error.response && error.response.status === 429) {
                    this.$dialog.notify.warning(
                        'Você solicitou o reenvio recentemente! Aguarde alguns minutos antes de tentar novamente.',
                        { position: 'top-right', timeout: 5000 }
                    );
                } 
                else {
                    this.$dialog.notify.error('Erro ao reenviar e-mail de verificação.', {
                        position: 'top-right',
                        timeout: 5000,
                    });
                }
            } finally {
                this.resending = false;
            }
        },

    }
};
</script>


<style lang="scss">
.title-page {
    color: var(--v-primary-base);
    font-family: Montserrat;
    font-size: 40px;
    font-style: normal;
    font-weight: 700;
    line-height: 38px;
}

p {
    text-align: justify;
}
</style>
